 
import styled from "styled-components";
import { CustomWidth } from "./CommonComponent";
import { CustomLabel } from "./CustomLabel";
import { ModalBody } from "./ModalStyles";

export const BenefitModalWrapper = styled.div`
  .enhancement-inputs {
    margin-top: 30px;
    margin-bottom: 50px;
  }
  ::placeholder {
    color: #555;
  }
  .back-btn {
    border: transparent;
    background: #fff;
    padding: 0px;
    width: auto;
    min-width: auto;
    margin-bottom: 20px;
    color: #5566bb;
    &:hover {
      color: #5566bb;
    }
    i::before {
      /* font-size: 22px; */
    }
  }
  .render-media {
    /* background-color: #eee; */
    border-radius: 10px;
    max-height: 175px;
    max-width: 175px;
    margin-left: 14px;
  }
  .selected-product-img {
    height: 175px;
    width: 175px;
    object-fit: contain; // cover is creating issue for wider images
    border-radius: 10px;
    /* margin-left: 14px; */
  }
  .back-arrow {
    height: 17px;
    width: 17px;
    margin-right: 7px;
  }
  ${CustomWidth}:first-child {
    height: calc(100vh - 340px);
    overflow: auto;
    &::-webkit-scrollbar {
      width: 0.4em;
      height: 0.6em;
      background: rgba(204, 204, 204, 1);
      border-radius: 10px;
    }
    &::-webkit-scrollbar-thumb {
      outline: 1px solid #ddd;
      background-color: rgba(21, 40, 55, 0.5);
      border-radius: 10px;
    }
  }
  .charcoal-label {
    // only for the light labels in benefit modal
    color: #aaa;
  }
  .labels-font-14 {
    ${CustomLabel},div,span {
      font-size: 14px;
      line-height: normal;
    }
  }
  .disabled-row {
    pointer-events: none;
    opacity: 0.8;
  }
  .select-items-table {
    width: 700px;
    border: none;
  }
  ${ModalBody} {
    overflow-x: hidden;
  }
  .add-item-btn {
    min-width: 30px;
    /* width: 30px; */
    height: 22px;
    padding: 0px 10px;
    font-size: 14px;
    line-height: 16px;
  }
  .dpdn-with-icons .header {
    padding: 8px 0px;
  }
  .selected-item-popup {
    max-height: 500px;
    height: 450px;
    min-height: 400px;
    .table-input-wrapper {
      height: auto;
    }
    ${CustomWidth}:first-child {
      /* height: calc(100vh - 340px); */
      height: auto;
    }
  }
  &.add-item-popup {
    .table.select-items-table {
      tbody {
        /* height: calc(100vh - 692px) !important; */
        max-height: 219px !important;
        height: auto !important
      }
      .plh-main-icon {
        height: 72px;
        width: 72px;
        margin-top: 40px;
      }
      .plh-label {
        font-size: 22px;
        margin: 20px auto 15px;
      }
    }
    .single-select-wrapper.dpdn-with-icons {
      .dropdown-option-list{
        max-height: 140px;
      }

    }
  }
`;
export const SaminarOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  /* height: 180px; */
  /* overflow-y: auto; */
  margin-bottom: 25px;
  &::-webkit-scrollbar {
    width: 0.4em;
    height: 0.6em;
    background: rgba(204, 204, 204, 1);
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    outline: 1px solid #ddd;
    background-color: rgba(21, 40, 55, 0.5);
    border-radius: 10px;
  }
  span {
    color: #ccc;
  }
`;
